/** Compact mode: the Denker widget, its chat menu, voice status and sign-in. */
export default {
  typeToDenker: "Type to Denker",
  typeHint: "{shortcut} to toggle input.",
  talkToDenker: "Talk to Denker",
  talkHint: "{shortcut} to talk; again sends.",
  workspace: "Workspace",
  workspaceHint: "Choose a project or space.",
  settings: "Settings",
  settingsHint: "Profile, voice, permissions.",
  agentEncounteredError: "{name} encountered an error",
  agentError: "Agent error",
  voiceUnavailable: "Voice unavailable",
  phaseSpeaking: "Speaking",
  phaseStartingLive: "Starting live…",
  phaseSending: "Sending",
  phaseSent: "Sent",
  phaseLive: "Live",
  phaseListening: "Listening",
  screenshotAttachmentOn: "{label}. Screenshot attachment on.",
  logoStarting: "Starting microphone.",
  logoSending: "Sending to Denker.",
  logoSent: "Sent to Denker.",
  logoSpeaking: "Denker is speaking.",
  logoLive: "Live mode.",
  logoListening: "Listening.",
  agentStatusError: "{name} has an error: open agent status",
  agentStatusThinking: "{name} is thinking: open agent status",
  agentStatusNewResult: "{name} has a new result: open agent status",
  agentStatusOpen: "{name}: open agent status",
  recentChats: "Recent Denker chats",
  noRecentChats: "No recent chats.",
  searchAllChats: "Search all chats",
  keyboardShortcuts: "Keyboard shortcuts",
  dockCursor: "Dock agent cursor",
  undockCursor: "Undock agent cursor",
  muteReplies: "Mute agent replies",
  speakReplies: "Speak agent replies",
  addProject: "Add project",
  homeProject: "Home project",
  screenshot: "Screenshot",
  backToSessions: "Back to recent sessions",
  openConversation: "Open conversation",
  openChatFailed: "Couldn't open the chat",
  sleeping: "Sleeping · say Denker",
  preparingMicrophone: "Preparing microphone…",
  noMicrophoneInput: "No microphone input",
  sayToInterrupt: 'Say "send" to interrupt',
  queued: "Queued",
  resizeChat: "Resize chat",
  aboutDenker: "About Denker",
  closeAbout: "Close About Denker",
  version: "Version {version}",
  previewVersion: "Version {version} · Preview",
  finishInBrowser: "Finish in your browser",
  signIn: "Sign in or create account",
  seeYouSoon: "See you soon",
} as const;
